import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { breakpoints, Container } from '../../../theme';

export const FooterContainer = styled.footer<{ $backgroundImage?: string }>`
  background-color: var(--color-background);
  color: var(--color-text);
  position: relative;
  z-index: 100;
  padding: 2rem 0;

  ${(props) =>
    props.$backgroundImage &&
    `
      background-image: url(${props.$backgroundImage});
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    `}
`;

export const FooterWrapper = styled(Container)`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (max-width: ${breakpoints.mobile}) {
    gap: 1.5rem;
  }
`;

/* --- Top Row: Logo, Nav, Social Icons --- */
export const TopRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;

  @media (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const LogoContainer = styled.div`
  flex: 0 0 auto;

  img {
    height: 80px;
    width: auto;
  }
`;

export const NavLinks = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;

  @media (min-width: ${breakpoints.tablet}) {
    justify-content: flex-start;
  }
`;

export const FooterLink = styled(Link)<{ $primary?: boolean }>`
  color: var(--color-text);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;

  &:hover {
    color: var(--color-link-hover);
  }

  ${(props) =>
    props.$primary &&
    `
      color: var(--color-primary);
      font-weight: bold;

      &:hover {
        color: var(--color-primary-hover);
      }
    `}

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.9rem;
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;

  a {
    color: var(--color-text);
    transition: color 0.3s, transform 0.3s;

    &:hover {
      color: var(--color-link-hover);
      transform: scale(1.1);
    }

    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

/* --- Bottom Row: Left & Right Text --- */
export const BottomRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  gap: 1rem;

  @media (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const FooterTextLeft = styled.p`
  text-align: center;
  font-size: 0.9rem;
  margin: 0;

  @media (min-width: ${breakpoints.tablet}) {
    text-align: left;
  }
`;

export const FooterTextRight = styled.p`
  text-align: center;
  font-size: 0.9rem;
  margin: 0;

  @media (min-width: ${breakpoints.tablet}) {
    text-align: right;
  }
`;
